import { BaseTransactionModel } from '@shared/app/scripts/classes/base-transaction-model';
import { SpynlBase } from '@shared/app/scripts/services/spynl-base';
import { Injectable } from 'angular-ts-decorators';
import type { IStandardErrorParser } from './standard-error-parser';
import type { IConfig } from './config';
import { Domain } from './domain';

/**
 * # Retail Transactions
 *
 * This service is used to interface with the /withdrawals/get spynl endpoint
 * The endpoint can return a sale, transit, or consignment and has various filters
 * that can be applied to requests.
 */
@Injectable('withdrawal')
export class Withdrawal extends SpynlBase<BaseTransactionModel> {
  constructor(
    protected $http: ng.IHttpService,
    protected $q: ng.IQService,
    protected sentry,
    protected domain: Domain,
    protected config: IConfig,
    protected standardErrorParser: IStandardErrorParser,
  ) {
    'ngInject';
    super(
      $http,
      $q,
      sentry,
      domain,
      config,
      standardErrorParser,
      BaseTransactionModel,
    );
    this.location = '/withdrawals';
  }

  /**
   * @param {string} _id
   * transaction id
   * @param {string} email
   * email we are sending to
   * @returns {promise}
   * resolve with response on success, otherwise reject with the error
   */
  email(_id: string, email: string): ng.IPromise<{}> {
    return this.$http
      .post(
        this.domain.getSpynl() + '/withdrawals/email',
        {
          _id,
          email,
        },
        {
          // done on config level for v7; setting for v6
          withCredentials: true,
        },
      )
      .then((response: any) => response.data.data);
  }

  /**
   * @returns {promise}
   * Resolve with response on success, otherwise reject with the error
   */
  startNew(): ng.IPromise<{}> {
    return this.$http
      .post(
        this.domain.getSpynl() + '/withdrawals/start-new',
        {},
        {
          // done on config level for v7; setting for v6
          withCredentials: true,
        },
      )
      .then((response: any) => response.data.data);
  }
}
